import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Heading,
} from '@chakra-ui/react';

const PAYOFF_EDUCATION_ITEMS = [
  {
    title: 'What Is a Payoff?',
    content:
      'Your payoff is the official amount required to purchase your car today. It’s based on your car’s residual value plus any remaining lease payments or interest.',
  },
  {
    title: 'Why You Need It',
    content:
      "It's required for loan comparisons, paperwork, and finalizing the buyout. Lenders and banks need this exact figure to process your purchase.",
  },
  {
    title: 'Why Lienholders Make It Complicated',
    content:
      'Outdated systems, hidden portals, and phone-only access slow things down. Most systems were designed for dealerships, not consumer buyouts.',
  },
  {
    title: 'How Lease End Solves This',
    content:
      'We retrieve and verify your payoff behind the scenes. Our system works directly with lenders to get you accurate information fast.',
  },
];

const EducationalContentPayoff = () => {
  return (
    <Box flex={1} w="100%">
      <Heading as="h2" size="md" mb={4}>
        Understanding Your Payoff
      </Heading>
      <Accordion allowToggle>
        {PAYOFF_EDUCATION_ITEMS.map((item, index) => (
          <AccordionItem
            key={item.title}
            borderTop={index === 0 ? 'none' : undefined}
            borderBottom={index === PAYOFF_EDUCATION_ITEMS.length - 1 ? 'none' : undefined}
          >
            <AccordionButton px={1} py={3}>
              <Box flex="1" textAlign="left" fontWeight="bold">
                {item.title}
              </Box>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel pb={4} px={1}>
              {item.content}
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </Box>
  );
};

export default EducationalContentPayoff;
